module.exports = __webpack_public_path__ + "img/HOME.a79f1a52.svg";